import React from 'react';
import '../Routes.css';

function Contact() {
  return (
    <div className="page__container">
      <h1 className="page__heading">Contact Us</h1>
    </div>
  );
}

export default Contact;
